import type { PumsemEdition } from '../model/pumsem.type';

interface PumsemEditionSelectProps {
  editions: PumsemEdition[];
  /** null 이면 "최신 발행판"(URL 에 판이 고정돼 있지 않은 상태). */
  value: string | null;
  onChange: (edition: string | null) => void;
}

/**
 * 개정판 선택.
 *
 * 첫 항목이 "최신"이고 값은 `null` 이다 — 판을 고르지 않은 상태와 우연히 최신
 * 판을 고른 상태는 **다른 링크**다. 전자는 반기마다 내용이 바뀌는 현행 주소고,
 * 후자는 그 판에 고정된 주소다. 견적서 근거로 붙일 링크는 후자여야 한다.
 */
export function PumsemEditionSelect({
  editions,
  value,
  onChange,
}: PumsemEditionSelectProps) {
  return (
    <label className="flex items-center gap-2 text-[14px]">
      <span className="sr-only">개정판</span>
      <select
        value={value ?? ''}
        onChange={(event) => onChange(event.target.value || null)}
        className="h-8 rounded-lg border border-neutral-200 bg-white px-2.5 text-[14px] font-medium text-neutral-800 dark:border-white/12 dark:bg-dark-card dark:text-neutral-100"
      >
        <option value="">최신 개정판</option>
        {/*
          목록에 없는 판(숨김·삭제·오타)이 URL 에 물려 있으면, 매칭되는 option
          이 없어서 브라우저가 **첫 항목인 "최신 개정판"** 을 그린다. 요청은
          여전히 그 슬러그로 나가므로 화면은 "최신" 이라고 말하면서 본문은
          "찾을 수 없습니다" 라고 답한다 — 실무자는 코드 오타를 의심하지만
          원인은 판이다. 견적서에 붙은 판 고정 링크가 숨겨지면 정확히 이 상태다.
        */}
        {value && !editions.some((edition) => edition.slug === value) && (
          <option value={value} disabled>
            {value} (없는 개정판)
          </option>
        )}
        {editions.map((edition) => (
          <option key={edition.slug} value={edition.slug}>
            {edition.label}
            {/* 관리 목록에서만 실려 오는 값이다. 일반 사용자에게는 애초에
                숨긴 판이 목록에 없으므로 이 꼬리표도 안 붙는다. */}
            {edition.isPublished === false ? ' (숨김)' : ''}
          </option>
        ))}
      </select>
    </label>
  );
}
